<template>
  <div class="top-filter-expression mdl-grid">

    <div class="top-expression mdl-card mdl-shadow--2dp mdl-cell--12-col"
         v-bind:class="[definition.classes, { expanded: filterExpanded }]">
      <div class="filterHideButton">
        <button v-if="filterExpanded" v-on:click="() => $emit('update:filterExpanded', false)"
                class="mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent">
          <i class="material-icons">expand_less</i></button>
        <button v-if="!filterExpanded" v-on:click="() => $emit('update:filterExpanded', true)"
                class="mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent">
          <i class="material-icons">expand_more</i></button>
      </div>

      <div class="args" v-if="filterExpanded">
        <div class="arg mdl-grid" v-if="definition.isList" v-for="(arg, argId) in expression.args">
          <TopFilterAndBlock :expression="arg" @update:expression="setArg(argId, $event)" :columns="columns"
                             :parent="definition" @delete="deleteArg(argId)"></TopFilterAndBlock>
        </div>
      </div>

      <div class="mdl-card__actions mdl-card--border" v-if="filterExpanded">
        <button v-if="!applied" @click="$emit('apply')"
                class="mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect">
          {{ i18n().apply }}
        </button>
        <button v-if="applied" @click="$emit('update')"
                class="mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect">
          {{ i18n().update }}
        </button>
        <button v-if="applied" @click="$emit('clear')"
                class="mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect">
          {{ i18n().clear }}
        </button>
      </div>

      <div v-if="!filterExpanded">
        <div class="mdl-card__supporting-text summary">
          {{ applied ? i18n().summary.activeFilter : i18n().summary.filter }}
          <span v-for="group in expression.args">
            <b>{{ group.type == 'and' ? 'include:' : 'exclude:'  }}</b>
            <span v-for="(andpart, aindex) in group.args">
              &nbsp;<b v-if="aindex > 0">and</b>
              <b v-if="andpart.args.length>1">(</b>
              <span v-for="(orpart, oindex) in andpart.args">
                &nbsp;<b v-if="oindex > 0">or</b>
                <u>{{ translateColumn(orpart.args[0]) }}</u>
                <b>{{ translateOperator(orpart.type) }}</b>
                <i>{{ translateColumn(orpart.args[1]) }}</i>
              </span>
              <b v-if="andpart.args.length>1">)</b>
            </span>
          </span>
        </div>
      </div>

    </div>

    <button v-if="definition.isList && filterExpanded"
            class="mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent add-button"
            v-on:click="addArg">
      <i class="material-icons">add</i>
    </button>

  </div>
</template>

<script>
import expression from "../../logic/expression.js"

import TopFilterAndBlock from "./TopFilterAndBlock"
import i18n from "i18n"

import api from "../../api"
import overlayModel from "../utils/overlayModel.js"
import PremiumOverlay from "../premium/PremiumOverlay.vue"


export default {
  name: 'filter-expression',
  props: {
    columns: {
      type: Array,
      default: function () {
        return []
      }
    },
    expression: {
      type: Object,
      default: function() {
        return {
          type: "and",
          args: []
        }
      }
    },
    parent: {
      type: Object,
      default: function() {
        return null
      }
    },
    applied: {
      type: Boolean
    },
    filterExpanded: {
      type: Boolean
    }
  },
  components: {
    TopFilterAndBlock: TopFilterAndBlock
  },
  data () {
    return {

    }
  },
  computed: {
    premium() {
      return api.session.premium
    },
    definition() {
      return expression.operatorsByName.get(this.expression.type)
    },
    possibleOperators() {
      /// TODO: filter operators by parent element type
      return expression.operators
    }
  },
  watch: {
  },
  methods: {
    showPremiumOverlay() {
      overlayModel.show({
        component: PremiumOverlay,
        props: {
        },
        on: {}
      })
    },
    i18n() { return i18n().filter },
    translateColumn(col) {
      return i18n().translateColumnName(col)
    },
    translateOperator(operator) {
      return this.i18n().operators[operator.title || operator] || "i18n:"+(operator.title || operator)
    },
    operatorDefinition(expr) {
      const operator = expression.operatorsByName.get(expr.type)
      console.log("OP", operator)
      return operator
    },
    addArg() {
      if(this.expression.args.length > 0 && !this.premium) return this.showPremiumOverlay();
      let narg = {
        "type": "and",
        args: [
          {
            "type": "or",
            args: [
              {
                "type": ">",
                "args": ["Count", 100]
              }
            ]
          }
        ]
      }
      this.$emit('update:expression', {
        type: this.expression.type,
        args: this.expression.args.concat([narg])
      })
    },
    setArg(argId, ev) {
      console.log("SET ARG", argId, ev)
      const nArgs = this.expression.args.slice()
      nArgs[argId] = ev
      this.$emit('update:expression', {
        type: this.expression.type,
        args: nArgs
      })
    },
    deleteArg(argId) {
      console.log("DELETE ARG", argId)
      const nArgs = this.expression.args.slice()
      nArgs.splice(argId, 1)
      this.$emit('update:expression', {
        type: this.expression.type,
        args: nArgs
      })
      if(this.applied) this.$emit('update')
    },
    deleteThis() {
      this.$emit('delete')
      if(this.applied) this.$emit('update')
    },
    updated () {
      componentHandler.upgradeAllRegistered()
    },
    mounted () {
      componentHandler.upgradeAllRegistered()
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .summary {
    padding: 3px 20px;
  }

  .filterHideButton {
    position: absolute;
    top: -16px;
    left: -16px;
    z-index: 2;
  }
  .filterHideButton > button {
    width: 28px;
    max-width: 28px;
    min-width: 28px;
    height: 28px;
    margin-left: 0px;
    margin-right: 12px;
    flex-grow: 0;
  }

  /*.expression {
    border: 1px solid rgba(0,0,0,0.4);
  }*/

  .top-filter-expression {
    position: relative;
    z-index: 2;
  }

  .top-expression > button {
    display: block;
    font-size: 0.77em;
    height: 2em;
    line-height: 2em
  }

  .top-expression > button i {
    font-size: 1.23em;
    line-height: 0.77em;
  }


  .add-button {
    position: absolute;
    right: 10px;
    bottom: 31px;
    width: 28px;
    max-width: 28px;
    min-width: 28px;
    height: 28px;
    z-index: 300;
  }
  .add-button i {
    font-size: 20px;
  }

  .mdl-card {
    overflow: visible;
    min-height: 0;
  }

  .arg {
    border-top: 1px solid lightgray;
  }
  .arg:nth-child(1) {
    border-top: none;
  }

  .mdl-card__actions {
    padding-top: 0;
    padding-bottom: 0;
  }
  .mdl-card__actions button {
    float: right;
  }

</style>



// WEBPACK FOOTER //
// TopFilterExpression.vue?445a864d